import type {PublicMethodUtils, PS} from '@wix/document-services-types'
import type {OptimusMigrationPublicAPI} from '@wix/document-services-public-types'
import {variants as variantsImpl} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {AppsInstallStateExtensionAPI} from '@wix/document-manager-extensions'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<OptimusMigrationPublicAPI> {
    const {defineGetter, defineAction} = publicMethodUtils

    const removeOverrideCodeReferenceId = (ps: PS): number => {
        const {appsInstallState} = ps.extensionAPI as AppsInstallStateExtensionAPI
        return appsInstallState.removeOverrideCodeReferenceId()
    }

    return {
        methods: {
            optimusMigration: {
                document: {
                    validate: publicMethodUtils.extensionPublicAPI.immediate('validation.validate')
                },
                components: {
                    innerElements: {
                        variants: {
                            getAllAffectingVariantsGroupedByVariantType: defineGetter(
                                variantsImpl.getAllAffectingVariantsGroupedByVariantTypeForInnerElement
                            )
                        }
                    }
                },
                appsState: {
                    removeOverrideCodeReferenceId: defineAction(removeOverrideCodeReferenceId)
                }
            }
        }
    }
}
